/** Render a seconds range as a compact human estimate, e.g. "≈ 2–4 min" / "≈ 30s". */
export function formatRange(lowSec: number, highSec: number): string {
  const fmt = (s: number) =>
    s < 90 ? { v: Math.round(s), u: "s" } : { v: Math.round(s / 60), u: " min" };
  const lo = fmt(lowSec);
  const hi = fmt(highSec);
  if (lo.v === hi.v && lo.u === hi.u) return `≈ ${lo.v}${lo.u}`;
  if (lo.u === hi.u) return `≈ ${lo.v}–${hi.v}${hi.u}`;
  return `≈ ${lo.v}${lo.u}–${hi.v}${hi.u}`;
}
